module.exports = __webpack_public_path__ + "static/media/leftPage.ab3fec3a.png";